module.exports = __webpack_public_path__ + "static/media/PRISM_5023.c4c5eb0c.jpg";